import type { PhotoMenu, PhotoListPageData, PhotoImageData, PhotoDetailPageData } from "../dto/photo-dto";
import api from "./axios";

export const getPhotoMenuRequest = async (
): Promise<PhotoMenu> => {
  const response = await api.get<PhotoMenu>('/photo/menu');
  return response.data;
};

export const getPhotoPageListDataRequest = async (
  year: string,
  set: string
): Promise<PhotoListPageData> => {
  const response = await api.get<PhotoListPageData>(`/photo/list/data/${year}/${set}`);
  return response.data;
};

export const getPhotoPageListImagesRequest = async (
  year: string,
  set: string
): Promise<PhotoImageData[]> => {
  const response = await api.get<PhotoImageData[]>(`/photo/list/${year}/${set}`);
  return response.data;
};

export const getPhotoImageByNameRequest = async (
  name: string
): Promise<Blob> => {
  var paths = name.split("/");
  const response = await api.get<Blob>(`/photo/image/detail/${paths[0]}/${paths[1]}/${paths[2]}`, {
    responseType: "blob"
  });
  return response.data;
};

export const getPhotoImageByPositionRequest = async (
  year: string,
  set: string,
  position: string
): Promise<Blob> => {
  const response = await api.get<Blob>(`/photo/image/position/${year}/${set}/${position}`, {
    responseType: "blob"
  });
  return response.data;
};

export const getPhotoPageDetailDataRequest = async (
  year: string,
  set: string
): Promise<PhotoDetailPageData> => {
  const response = await api.get<PhotoDetailPageData>(`/photo/detail/data/${year}/${set}`);
  return response.data;
};
